// Home page click-through: one GA4 `home_click` event per product or link clicked on the home page.
// Uses GA4's built-in link dimensions, like `menu_click`, so nothing needs registering in GA4 Admin:
//   link_classes = row ("new_this_week", "coming_soon", "bestsellers:<tab>", "recently_viewed",
//                  "because_viewed", "hero", "trust", "faq", "brands", "newsletter")
//   link_url     = destination, link_text = product title or link text.
// Only sends when the Google tag has loaded (it is consent-gated).
(function () {
  var ROWS = {
    yc_home_top: 'hero', featured_collection_EkQmbH: 'new_this_week', coming_soon: 'coming_soon',
    'products-tabs': 'bestsellers', yc_home_personal: 'recently_viewed', multicolumn: 'trust',
    collapsible_content_PeMawq: 'faq', brands_8QLkgd: 'brands', newsletter_4xFncj: 'newsletter',
    yc_home_season: 'seasonal', yc_home_trust: 'trust', yc_home_help: 'faq_newsletter', yc_home_brands: 'brands', yc_home_reviews: 'reviews'
  };
  function row(a) {
    var r = a.closest('[data-yc-row]');
    if (r) return r.getAttribute('data-yc-row');
    var s = a.closest('[id^="shopify-section-"]');
    if (!s) return null;
    var key = s.id.split('__').pop();
    var name = ROWS[key] || key;
    if (name === 'bestsellers') {
      var tab = s.querySelector('.products-tabs__tab.active');
      if (tab) name += ':' + tab.textContent.trim();
    }
    return name;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || typeof window.gtag !== 'function' || !a.closest('main')) return;
    var name = row(a);
    if (!name) return;
    var card = a.closest('.card-wrapper, .product-card, .card');
    var title = card && card.querySelector('.card__heading, .card__title, h3');
    try {
      window.gtag('event', 'home_click', {
        link_classes: name,
        link_url: a.href,
        link_text: ((title && title.textContent) || a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100),
        transport_type: 'beacon'
      });
    } catch (err) {}
  }, true);
})();
